import React, {useEffect} from "react"
import {message} from "antd"
import useTranslation from 'next-translate/useTranslation'

// Components
import SignUpForm from "./components/SignUpForm"
import UnauthorizedPage from "../../../../components/UnauthorizedPage"
import AuthHeader from "../../components/AuthHeader"

// Hooks
import usePrevious from "../../../../hooks/usePrevious"

// Models
import {SignUpPageProps} from "../../../../../pages/sign-up"

// Constants
import {Routes} from "../../../../constants"

const SignUpPage = (props: SignUpPageProps) => {
    const {className, signUp, signingUp, signedUp, router} = props
    const previousSignedUp = usePrevious(signedUp)
    const { t } = useTranslation();

    useEffect(() => {
        if (typeof previousSignedUp !== "undefined" && previousSignedUp !== signedUp && signedUp === true) {
            message.success(t('common:auth.sign_up_succeeded_text'))
            void router.push(Routes.SIGN_IN)
        }
    }, [signedUp])

    return (
        <UnauthorizedPage title="Sign up" className={className}>
            <AuthHeader
                title={t('common:auth.already_have_an_account')}
                href={Routes.SIGN_IN}
                buttonText={t('common:auth.sign_in')}
            />
            <SignUpForm onSubmit={signUp} loading={signingUp}/>
        </UnauthorizedPage>
    )
}

export default SignUpPage;